import PropTypes from 'prop-types';

const commentProps = {
  created_at: PropTypes.string,
  draft: PropTypes.bool,
  id: PropTypes.number.isRequired,
  offset: PropTypes.number,
  parent_id: PropTypes.number,
  raw_text: PropTypes.string,
  image_urls: PropTypes.arrayOf(PropTypes.string),
  comment_image_is_blessed: PropTypes.bool,
  safe_html: PropTypes.string.isRequired,
  star_rating: PropTypes.number,
  type: PropTypes.oneOf(['review', 'question', 'note', 'response']),
  updated_at: PropTypes.string,
  user: PropTypes.shape({
    author_id: PropTypes.string,
    avatar: PropTypes.string,
    display_name: PropTypes.string,
    id: PropTypes.number,
  }),
};

export default PropTypes.shape({
  ...commentProps,
  responses: PropTypes.arrayOf(PropTypes.shape(commentProps)),
});
